var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextcarouselControls1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#CE8F68"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.706 22L13 21.294L17.9405 16.3535C18.0342 16.2597 18.0869 16.1326 18.0869 16C18.0869 15.8674 18.0342 15.7402 17.9405 15.6465L13.0085 10.7155L13.7155 10.0085L18.6465 14.9395C18.9277 15.2208 19.0857 15.6022 19.0857 16C19.0857 16.3977 18.9277 16.7792 18.6465 17.0605L13.706 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextcarouselControls1);
export default __webpack_public_path__ + "static/media/Nextcarousel-controls-1.b7113a769fb9446221fd13429da92ff7.svg";
export { ForwardRef as ReactComponent };